import { useTranslation } from '@/hooks/useTranslation';

const TickerSection = () => {
  const { t } = useTranslation();
  const items = t.ticker.items;
  const all = [...items, ...items];

  return (
    <div className="ticker-wrap">
      <div className="ticker-inner">
        {all.map((item, i) => (
          <span key={i}>{item}</span>
        ))}
      </div>
    </div>
  );
};

export default TickerSection;
